import _ from 'lodash';

import React from 'react';
import {FormattedMessage} from 'react-intl';
import {inject, observer} from 'mobx-react';

import PCPageLoading from '../../../shared/components/page-loading/page-loading.component';

@inject('checkoutStore')
@observer
class PCCheckoutStepPaymentMethod extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        this.props.checkoutStore.paymentMethodId = event.target.value;
    }

    render() {
        const paymentMethods = this.props.checkoutStore.paymentMethods;

        if (paymentMethods === undefined) {
            return (
                <PCPageLoading/>
            );
        }

        if (paymentMethods === null) {
            return (
                <div className='alert alert-warning'>
                    <FormattedMessage
                        defaultMessage='Unable to load the payment methods.'
                        id='pc-checkout-payment-method.error'
                    />
                </div>
            );
        }

        const paymentMethodRows = _.map(
            paymentMethods,
            (paymentMethod) => {
                return (
                    <div
                        className='radio'
                        key={paymentMethod.paymentMethodId}
                    >
                        <label>
                            <input
                                checked={
                                    paymentMethod.paymentMethodId == this.props.checkoutStore.paymentMethodId // eslint-disable-line eqeqeq
                                }
                                name='payment-method'
                                onChange={this.onChange}
                                type='radio'
                                value={paymentMethod.paymentMethodId}
                            />
                            <span/>
                            {paymentMethod.paymentMethodText}
                        </label>
                    </div>
                );
            }
        );

        return (
            <div className='checkout-step-payment-method container-fluid'>
                <h5 className='row'>
                    <FormattedMessage
                        defaultMessage='Choose your payment method'
                        id='pc-checkout-payment-method.choose'
                    />
                </h5>
                <div className='row'>
                    {paymentMethodRows}
                </div>
                <div className='row limit-width'>
                    <button
                        className='btn btn-primary btn-continue'
                        disabled={this.props.checkoutStore.paymentMethodId === null}
                        onClick={this.props.checkoutStore.activateNextStep}
                    >
                        <FormattedMessage
                            defaultMessage='Continue'
                            id='pc.continue'
                        />
                    </button>
                </div>
            </div>
        );
    }
}

export default PCCheckoutStepPaymentMethod;
